module.exports = __webpack_public_path__ + "img/ground-ground-night.2485e9fc.png";